module.exports = __webpack_public_path__ + "files/fba8b2a7052485cec44b825aaeb05d71.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700italic.woff2
 ** module id = 965
 ** module chunks = 0
 **/